<template>
    <tbody>
        <template v-for="child in children">
            <tr
                :key="`row_${child.id}`"
                :id="`childRow_${child.id}`"
                class="childrenRow"
                :data-parent-id="parentId"
                style="display:none;"
            >
                <td v-if="bulkActionsAvailable">
                    <input
                        v-if="isAdmin || ((tabStatus == 'n' && child.sug_price) || (tabStatus == 'p' && child.canBeSignedOffOn) || (tabStatus == 'a'))"
                        type="checkbox"
                        class="submissionId"
                        :value="child.id"
                        v-model="localSelectedIds"
                    />
                    <input v-else type="checkbox" disabled="disabled" style="cursor:not-allowed;" />
                </td>
                <td>
                    <a @click="$emit('toggle-details', child.id, child.isMulti)" style="cursor:pointer;">
                        <span class="arrow-down">&#x25BC;</span>
                    </a>
                    {{ child.timestamp }}
                </td>
                <td>{{ child.cust_id }}</td>
                <td>{{ child.company }}</td>
                <td>
                    <img v-if="child.urgent" src="/images/price-workflow/icon-circle-important.png" style="position:relative; height:1rem; width:auto;">
                    {{ child.activity.activity }}
                </td>
                <td v-if="tabStatus == 'p'" style="text-transform:uppercase;">{{ child.currentStep }}</td>
                <td>{{ child.rationale }}</td>
                <td v-if="child.act_id == 2 && child.ord_num" v-html="child.ord_num"></td>
                <td v-else>{{ child.eff_date }}</td>
                <td>
                    <img v-if="child.tariff_flag" src="/images/price-workflow/icon-alert.gif" style="position:relative; height:1rem; width:auto;">
                    {{ child.prod_key }}
                </td>
                <td>{{ child.sug_price }} {{ child.uom }}<span class="deviatedFlag" v-if="child.on_deviated == '1'">*</span></td>
                <td>{{ child.sug_var }}</td>
                <td>{{ child.proj_sales }}</td>

                <td v-if="tabStatus != 'n'" class="iconTd">
                    <router-link :to="{ name: 'PriceWorkflowSignoff', params: { ppId: child.id } }">
                        <img class="iconImg" src="/images/icon-circle-view-green.png" />
                    </router-link>
                    <p class="iconLabel">VIEW</p>
                </td>
                <td v-else class="iconTd">&nbsp;</td>

                <td v-if="tabStatus == 'a'" class="iconTd">
                    <a @click="$emit('open-export-modal', child.id)">
                        <img class="iconImg" src="/images/icon-circle-download.png" alt="Download ERP Export" />
                    </a>
                    <p class="iconLabel">EXPORT</p>
                </td>

                <td v-if="tabStatus == 'n' || (tabStatus == 'd' && child.edittableByCurrUser)" class="iconTd">
                    <router-link :to="{ 
                            name: 'PriceWorkflowSkuSelect', 
                            params: {ppId: child.id},
                            query: { editing: 'true' }
                        }"
                    >
                        <img class="iconImg" src="/images/icon-circle-edit.png" />
                    </router-link>
                    <p class="iconLabel">EDIT</p>
                </td>

                <td v-if="tabStatus == 'n' || (user.user_group_id != 10)" class="iconTd">
                    <a @click="$emit('delete-entry', child.id)">
                        <img class="iconImg" src="/images/icon-circle-trash.png" />
                    </a>
                    <p class="iconLabel">DELETE</p>
                </td>
            </tr>

            <dev-dashboard-add-details-row
                :key="`details_${child.id}`"
                :entry="child"
            />
        </template>
    </tbody>
</template>

<script>
export default {
    props: {
        children: {
            type: Array,
            required: true
        },
        parentId: {
            type: [String, Number],
            required: true
        },
        bulkActionsAvailable: {
            type: Boolean,
            default: false
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        tabStatus: {
            type: String,
            default: ''
        },
        selectedIds: {
            type: Array,
            default: () => []
        },
        user: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        localSelectedIds: {
            get() {
                return this.selectedIds;
            },
            set(value) {
                this.$emit('update:selectedIds', value);
            }
        }
    }
}
</script>

<style scoped>
    .iconImg {
        height:26px; 
        width:auto;
    }

    .iconTd {
        text-align:center; 
        width:2%;
        cursor: pointer;
    }

    .iconLabel {
        font-size:0.6rem; 
        color:#999;
    }

    .submissionTBL td {
        padding: 1rem .25rem 1rem 0;
        background: #fafafa;
        border-bottom: dotted 1px #ccc;
    }

    .arrow-down {
        cursor: pointer;
        font-size: .6rem;
    }

    .arrow-down:hover {
        color: #cd1b00;
    }

    .deviatedFlag {
        color: red;
        font-weight: bold;
        margin-left: 2px;
    }
</style>
